import { FileDown, ImageDown } from "lucide-react";
import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import { VISIT_PDF } from "../../../../api/allApi_List";

VisitModalLayout.VisitDownloads = function VisitDownloads() {
  const {
    visit,
    generateReportPdf,
    generateImagePdf,
    isReportPdfLoaded,
    isImagePdfLoaded,
    restReportPdf,
    restImagePdf,
  } = useVisitDialog();

  const visitId = visit.id;
  const station = visit.station?.name;

  // Generate Visit Report PDF
  const handleReportPdf = () => {
    generateReportPdf(
      VISIT_PDF + visitId + "/pdf",
      `Visit_${station}_${visitId}`,
    );
  };

  // Generate Visit Image PDF
  const handleImagePdf = () => {
    generateImagePdf(
      VISIT_PDF + visitId + "/pdfImages",
      `Visit_${station}_${visitId}`,
    );
  };
  return (
    <>
      <div className="gap-2 mt-2 md:flex-center-align max-md:space-y-2 text-[14px]">
        <button
          className={buttonStyle}
          onClick={handleReportPdf}
          disabled={isReportPdfLoaded}
        >
          {!isReportPdfLoaded ? (
            <>
              {" "}
              <FileDown size={16} />
              <span> Report PDF</span>
            </>
          ) : (
            "Loading..."
          )}
        </button>
        <button
          className={buttonStyle}
          onClick={handleImagePdf}
          disabled={isImagePdfLoaded}
        >
          {!isImagePdfLoaded ? (
            <>
              {" "}
              <ImageDown size={16} />
              <span> Image PDF</span>
            </>
          ) : (
            "Loading..."
          )}
        </button>
      </div>
      {restReportPdf.error && (
        <p className={errorStyle}>{restReportPdf.error}</p>
      )}
      {restImagePdf.error && <p className={errorStyle}>{restImagePdf.error}</p>}
    </>
  );
};

const buttonStyle =
  "flex-center-align gap-1 text-blue-500 border p-1 px-2 rounded-md border-blue-300 shadow-200 hover:shadow-100";
const errorStyle = "text-xs text-red-500 text-center pt-3";
